import { ReloadWrapper } from './Reload.styles';
import { Button } from '../ui/Button';
import { Typography } from '../ui/Typography';

type Props = {
  message?: string;
};

const handleClick = () => {
  window.location.reload();
};

function Reload({ message = "There's a new version of this app!" }: Props): JSX.Element {
  return (
    <ReloadWrapper data-test-id="reload">
      <Typography.Title level={5}>{message}</Typography.Title>
      <Button onClick={handleClick}>Reload</Button>
    </ReloadWrapper>
  );
}

export { Reload };
